import { isEmpty } from 'lodash';

import { checkIfIsArray, isDefined } from '@e-socna/utils';

const DEFAULT_FIELDS_TO_IGNORE = ['_id', '__typename'] as const;

interface Params {
  readonly node?: unknown;
  readonly ignore?: readonly string[];
}

export const isFormEmpty = ({ node, ignore }: Readonly<Params>): boolean => {
  if (!isDefined(node)) {
    return true;
  }

  if (!(
    typeof node === 'object' ||
    checkIfIsArray(node) ||
    typeof node === 'string'
  )) {
    return false;
  }

  if (!node || isEmpty(node)) {
    return true;
  }

  if (checkIfIsArray(node)) {
    return node.every((value: unknown) => isFormEmpty({ node: value }));
  }

  if (node instanceof Object) {
    const entries = Object.entries(node).filter(
      ([key]: readonly [string, unknown]) =>
        !(ignore ?? DEFAULT_FIELDS_TO_IGNORE).includes(key),
    );

    return entries.every(([_key, value]: readonly [string, unknown]) =>
      isFormEmpty({ node: value }),
    );
  }

  return false;
};
